// extracted by mini-css-extract-plugin
module.exports = {"content":"TextContent_content__2yToh","smileWrap":"TextContent_smileWrap__2Qr-C","smile":"TextContent_smile__QFCrc"};